export var EntityStateEnum;
(function (EntityStateEnum) {
    EntityStateEnum["DRAFT"] = "draft";
    EntityStateEnum["SCHEDULED"] = "schedule";
    EntityStateEnum["PUBLISHED"] = "publish";
    EntityStateEnum["EXPIRED"] = "unpublish";
})(EntityStateEnum || (EntityStateEnum = {}));
/* eslint-disable @typescript-eslint/naming-convention */
// the error is: we should use camelCase, UPPER_CASE, PascalCase
// WAITING FOR UPLOAD => WAITING_FOR_UPLOAD
export var XymaticVideoStatusEnum;
(function (XymaticVideoStatusEnum) {
    XymaticVideoStatusEnum[XymaticVideoStatusEnum["SCHEDULED"] = 0] = "SCHEDULED";
    XymaticVideoStatusEnum[XymaticVideoStatusEnum["RUNNING"] = 1] = "RUNNING";
    XymaticVideoStatusEnum[XymaticVideoStatusEnum["COMPLETE"] = 2] = "COMPLETE";
    XymaticVideoStatusEnum[XymaticVideoStatusEnum["PROGRESSING"] = 3] = "PROGRESSING";
    XymaticVideoStatusEnum[XymaticVideoStatusEnum["WAITING FOR UPLOAD"] = 4] = "WAITING FOR UPLOAD";
    XymaticVideoStatusEnum[XymaticVideoStatusEnum["UPLOADED"] = 5] = "UPLOADED";
    XymaticVideoStatusEnum[XymaticVideoStatusEnum["ERROR"] = 6] = "ERROR";
    XymaticVideoStatusEnum[XymaticVideoStatusEnum["STOPPING"] = 7] = "STOPPING";
    XymaticVideoStatusEnum[XymaticVideoStatusEnum["DELETED"] = 8] = "DELETED";
    XymaticVideoStatusEnum[XymaticVideoStatusEnum["STARTING"] = 9] = "STARTING";
    XymaticVideoStatusEnum[XymaticVideoStatusEnum["CREATING"] = 10] = "CREATING";
    XymaticVideoStatusEnum[XymaticVideoStatusEnum["STOPPED"] = 11] = "STOPPED";
    XymaticVideoStatusEnum[XymaticVideoStatusEnum["STARTED"] = 12] = "STARTED";
    XymaticVideoStatusEnum[XymaticVideoStatusEnum["FINISHED"] = 13] = "FINISHED";
})(XymaticVideoStatusEnum || (XymaticVideoStatusEnum = {}));
//# sourceMappingURL=types.js.map